module.exports = require('./CheckCasherBranchApplicationView');
